module.exports = require('./CheckCasherBranchApplicationView');
